export const COUNTRY_CHANGE_CONFIRMATION = {
  TITLE: 'Change Country',
  MESSAGE:
    'You are changing the country, do you want to delete the current survey?',
  DELETE_LABEL: 'Yes, delete the survey',
  KEEP_LABEL: 'No, keep the survey as a draft',
  CANCEL_LABEL: 'Cancel',
} as const;

export type TargetingLossKind =
  | 'qualifications'
  | 'census-quotas'
  | 'advanced-qualifications'
  | 'quota-reset';

export const COUNTRY_CHANGE_LOSS_MESSAGES: Record<TargetingLossKind, string> = {
  qualifications:
    "The new country doesn't support <names> qualifications applied before, therefore are removed.",
  'census-quotas':
    "The new country doesn't contain census data for <names> quotas applied before, therefore are removed.",
  'advanced-qualifications':
    "The new country doesn't support <names> advanced targeting applied before, therefore are removed.",
  'quota-reset':
    "The new country doesn't have the same qualifications and/or conditions, therefore any qualification/quota are reset.",
};

export const COUNTRY_CHANGE_NAMES_PLACEHOLDER = '<names>';

export const DRAFT_SURVEY_DELETED_MESSAGE =
  'Success! Draft survey has been deleted.';
